/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

import checkMark from '../../assets/images/сheck_mark.svg';

const createBoxPickerStyle = makeStyles(theme => ({
  default: {
    border: '2px solid transparent',
    borderRadius: '6px',
    minWidth: '80px',
    minHeight: '50px',
    position: 'relative',
    display: 'flex',
    flex: '0 0 auto',
  },
  focus: {
    '&:focus': {
      outline: 'none',
      animation: '$focused 1500ms infinite linear alternate',
    },
  },
  isActive: {
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    '&:before': {
      display: 'block',
      position: 'absolute',
      content: '""',
      top: '0px',
      right: '0px',
      borderStyle: 'solid',
      borderWidth: '0 40px 40px 0',
      borderColor: `transparent ${theme.palette.primary.main} transparent transparent`,
      zIndex: 1,
    },
    '&:after': {
      display: 'block',
      position: 'absolute',
      content: '""',
      top: '4px',
      right: '4px',
      width: '13px',
      height: '10px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundImage: `url('${checkMark}')`,
      zIndex: 1,
    },
  },
  '@keyframes focused': {
    from: {
      border: '2px solid',
      borderColor: theme.palette.primary.main,
    },
    to: {
      border: '2px solid',
      borderColor: theme.palette.tertiary.main,
    },
  },
}));

export { createBoxPickerStyle };
